import React, { useState } from 'react';
import "./multiselect.css";
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp, faSquare, faCheckSquare} from '@fortawesome/pro-regular-svg-icons';

const MultiSelectDropdown = ({options, selectedOptions, setSelectedOptions, allOptions}) => {
  
    const [showOptions, setShowOptions] = useState(false);
    const allOptionsArray = allOptions ? [...options, allOptions] : options;


    const handleOptionClick = (option) => {
        if (option === allOptions) {
            if (selectedOptions.length === options.length) {
                setSelectedOptions([]);
              } else {
                setSelectedOptions(options);
              }
        } else {
        setSelectedOptions((prevSelectedOptions) => {
            if (prevSelectedOptions.includes(option)) {
                return prevSelectedOptions.filter((item) => item !== option);
            } else {
                return [...prevSelectedOptions, option];
            }
        });
    }};

  const toggleOptions = () => {
    setShowOptions((prevShowOptions) => !prevShowOptions);
  };

  const isAllOptionsSelected = selectedOptions.length === options.length;
  const isSelected = (option) => {return selectedOptions.includes(option) || (option === allOptions && isAllOptionsSelected)}


  const headerText = (selectedOptions) => {
    const length = selectedOptions.length
    if (length == 0){
        return "Select"
    }
    return `${length} Option${pluralS(length)} selected`
  }

  const pluralS = (length) => {
    if (length == 1) {
        return ""
    }
    else {
        return "s"
    }
  }

    return (
        <div className="multi-select-dropdown">
            <div className="multi-header" onClick={toggleOptions}>
                {headerText(selectedOptions)}
                <span className="multi-arrow">{showOptions ? <FontAwesomeIcon icon={faAngleUp}/> : <FontAwesomeIcon icon={faAngleDown}/>}</span>
            </div>
            {showOptions && (
                <div className="multi-list">
                    {allOptionsArray.map((option) => (
                <div
                    key={option}
                    className='multi-list-item'
                    onClick={() => handleOptionClick(option)}
                >
                    <FontAwesomeIcon icon={isSelected(option) ? faCheckSquare : faSquare}/> {option}
                </div>
            ))}
            </div>
        )}
        </div>
    );
        };

export default MultiSelectDropdown;



// WEBPACK FOOTER //
// ./src/components/shared/Multiselect/index.js